import React, { useMemo } from 'react';
import GenericListPage from '../GenericListPage';
import PurchaseOrderForm from './PurchaseOrderForm';
import { Link } from 'react-router-dom';

const PurchaseOrdersPage = () => {
  const columns = useMemo(() => [
    { header: 'PO #', key: 'reference', render: r => r.reference || (r._id || '—') },
    { header: 'Supplier', key: 'supplier', render: r => r.supplier?.name || r.supplier || '—' },
    { header: 'Location', key: 'location', render: r => `${r.location?.type || '—'} ${r.location?.id || ''}` },
    { header: 'Items', key: 'items', render: r => Array.isArray(r.items) ? r.items.length : (r.itemsCount ?? '—') },
    { header: 'Expected Delivery', key: 'expectedDeliveryDate', render: r => r.expectedDeliveryDate ? new Date(r.expectedDeliveryDate).toLocaleDateString() : '—' },
    { header: 'Status', key: 'status', render: r => r.status || '—' },
    { header: 'Created', key: 'createdAt', render: r => r.createdAt ? new Date(r.createdAt).toLocaleString() : '—' }
  ], []);

  const headerActions = (
    <div className="flex items-center gap-2">
      <Link to="/purchase-orders/create">
        <button className="bg-green-600 text-white px-3 py-1 rounded text-sm">+ New PO</button>
      </Link>
    </div>
  );

  const filterConfig = [
    { name: 'status', type: 'select', label: 'Status', options: [{ value: '', label: 'Any' }, { value: 'Draft', label: 'Draft' }, { value: 'Open', label: 'Open' }, { value: 'Received', label: 'Received' }] },
    { name: 'supplier', type: 'text', label: 'Supplier ID' },
    { name: 'locationType', type: 'select', label: 'Location Type', options: [{ value: '', label: 'Any' }, { value: 'store', label: 'Store' }, { value: 'warehouse', label: 'Warehouse' }] }
  ];

  return (
    <GenericListPage
      title="Purchase Orders"
      permission="manage_purchase_orders"
      entityEndpoint="purchase-orders"
      columns={columns}
      FormComponent={PurchaseOrderForm}
      filterConfig={filterConfig}
      headerActions={headerActions}
    />
  );
};

export default PurchaseOrdersPage;